var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwaDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#61BD85",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.19 10H15.81C12.17 10 10 12.17 10 15.81V24.18C10 27.83 12.17 30 15.81 30H24.18C27.82 30 29.99 27.83 29.99 24.19V15.81C30 12.17 27.83 10 24.19 10ZM16.47 18.98C16.76 18.69 17.24 18.69 17.53 18.98L19.25 20.7V14.51C19.25 14.1 19.59 13.76 20 13.76C20.41 13.76 20.75 14.1 20.75 14.51V20.7L22.47 18.98C22.76 18.69 23.24 18.69 23.53 18.98C23.82 19.27 23.82 19.75 23.53 20.04L20.53 23.04C20.46 23.11 20.38 23.16 20.29 23.2C20.2 23.24 20.1 23.26 20 23.26C19.9 23.26 19.81 23.24 19.71 23.2C19.62 23.16 19.54 23.11 19.47 23.04L16.47 20.04C16.18 19.75 16.18 19.28 16.47 18.98ZM26.24 25.22C24.23 25.89 22.12 26.23 20 26.23C17.88 26.23 15.77 25.89 13.76 25.22C13.37 25.09 13.16 24.66 13.29 24.27C13.42 23.88 13.84 23.66 14.24 23.8C17.96 25.04 22.05 25.04 25.77 23.8C26.16 23.67 26.59 23.88 26.72 24.27C26.84 24.67 26.63 25.09 26.24 25.22Z",
    fill: "#61BD85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwaDownloadIcon);
export default __webpack_public_path__ + "static/media/pwa-download-icon.714e46d46f48de4e247a3896063c4ae6.svg";
export { ForwardRef as ReactComponent };